<template>
    <v-row>
        <v-dialog @keydown.enter="recoverPassword()" @keydown.esc="close()" persistent v-model="dialog" height="90%" max-width="350px" max-height="500px">
            <v-card>
                <v-card-title> Recuperar senha </v-card-title>

                <v-card-subtitle> Enviaremos para você a sua nova senha. Qual e-mail está cadastrado? </v-card-subtitle>

                <v-card-text>
                    <v-row class="w-100">
                        <v-col xs="12" sm="12" md="12" lg="12" class="no-pd-l no-pd-r no-pd-b">
                             <v-text-field
                                placeholder=" "
                                label=" Email cadastrado"
                                color="var(--cor--preta)"
                                class="no-mg-t"
                                v-model="recoverPasswordEmail"
                                clearable
                                autofocus
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="flex-row-end">
                    <v-btn class="text-none" text color="var(--cor--cinzaApp)" :disabled="updateBtnRecoveryLoading" @click="close()"> Fechar </v-btn>
                    <v-btn class="text-none" text color="#AC50FF" @click="recoverPassword()" :loading="btnRecoveryLoading"> Enviar </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { recoverPasswordByEmail } from "./service/recoverPassword-service";

export default {
    name: 'RecoverPasswordModal',
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        ),
    },
    data: () => ({
        recoverPasswordEmail: null,
        btnRecoveryLoading: false,
        updateBtnRecoveryLoading: false
    }),
    methods: {
        close() {
            this.recoverPasswordEmail = null
            this.$emit("closeRecoverPasswordModal", false);
        },
        recoverPassword() {   
            if( this.recoverPasswordEmail != '' && this.recoverPasswordEmail != null ) {
                this.btnRecoveryLoading = true
                this.btnRecoveryLoading ?  this.updateBtnRecoveryLoading = true : ''
                recoverPasswordByEmail( this.currentCompany.id, this.recoverPasswordEmail )
                    .then( () => {
                            this.close()
                            this.$toasted.show('Senha enviada para seu e-mail!.', { type: 'success' } )
                        }
                    )
                    .catch( error => {
                            if( error != null ) {
                                this.$toasted.show(error.message, { type: 'error' } )
                            }                            
                        }
                    )
                    .finally(() => {
                            this.btnRecoveryLoading = false
                            this.updateBtnRecoveryLoading = false
                        }
                    )
                    
            } else {
                this.btnRecoveryLoading = false
                this.$toasted.show('E-mail obrigatório.', { type: 'info' } )
            }
        }
    }
}
</script>